import React from 'react';

// Spec §13 — gray outer canvas, white inner page. Pages without `fullWidth`
// get a max content width so dense text/forms don't stretch edge-to-edge on
// large monitors; `fullWidth` pages (e.g. wizards, wide tables) opt out.
const PageCanvas = ({ children, fullWidth = false, className = '' }) => {
  return (
    <div className={`flex-1 flex flex-col bg-surfaceMuted min-h-full w-full ${className}`}>
      <div
        className={`flex-1 flex flex-col gap-5 bg-white text-textPrimary p-4 md:p-6 lg:p-8 w-full ${
          fullWidth ? '' : 'max-w-[1280px] mx-auto'
        }`}
        style={{ fontSize: '0.875rem', lineHeight: 1.5 }}
      >
        {children}
      </div>
    </div>
  );
};

export default PageCanvas;
